import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_EASTER_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_EASTER_80,
  },
  {
    pageId: PageId.CHAT_UPSELL_EASTER_80,
  },
  {
    pageId: PageId.UPSELL_EASTER_80,
  },
  {
    pageId: PageId.DOWNLOAD_EASTER_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
